import { useEffect, useState } from "react";

import API_URL from "../apiConfig";


function AdminFeedback({
    token,
    checkResponse
}) {

    const [feedbacks, setFeedbacks] =
        useState([]);


    // ==================================================
    // FEEDBACKS LADEN
    // ==================================================

    function loadFeedbacks() {

        fetch(
            `${API_URL}/admin-feedback.php`,
            {
                credentials: "include",

                headers: {
                    "Authorization":
                        `Bearer ${token}`
                }
            }
        )

            .then(checkResponse)

            .then((data) => {

                setFeedbacks(data);
            })

            .catch((error) => {

                console.error(
                    "Fehler beim Laden der Feedbacks:",
                    error
                );
            });
    }


    // ==================================================
    // BEIM ÖFFNEN LADEN
    // ==================================================

    useEffect(() => {

        loadFeedbacks();

    }, []);


    // ==================================================
    // FEEDBACK FREIGEBEN
    // ==================================================

    function handleFreigeben(id) {

        fetch(
            `${API_URL}/admin-feedback.php?id=${id}&action=freigeben`,
            {
                method: "PUT",

                credentials: "include",

                headers: {
                    "Authorization":
                        `Bearer ${token}`
                }
            }
        )

            .then(checkResponse)

            .then(() => {

                loadFeedbacks();
            })

            .catch((error) => {

                console.error(
                    "Fehler beim Freigeben:",
                    error
                );
            });
    }


    // ==================================================
    // FEEDBACK WIEDER AUSBLENDEN
    // ==================================================

    function handleSperren(id) {

        fetch(
            `${API_URL}/admin-feedback.php?id=${id}&action=sperren`,
            {
                method: "PUT",

                credentials: "include",

                headers: {
                    "Authorization":
                        `Bearer ${token}`
                }
            }
        )

            .then(checkResponse)

            .then(() => {

                loadFeedbacks();
            })

            .catch((error) => {

                console.error(
                    "Fehler beim Ausblenden:",
                    error
                );
            });
    }


    // ==================================================
    // FEEDBACK LÖSCHEN
    // ==================================================

    function handleDelete(id) {

        const confirmed =
            window.confirm(
                "Möchtest Du dieses Feedback wirklich löschen?"
            );


        if (!confirmed) {
            return;
        }


        fetch(
            `${API_URL}/admin-feedback.php?id=${id}`,
            {
                method: "DELETE",

                credentials: "include",

                headers: {
                    "Authorization":
                        `Bearer ${token}`
                }
            }
        )

            .then(checkResponse)

            .then(() => {

                loadFeedbacks();
            })

            .catch((error) => {

                console.error(
                    "Fehler beim Löschen des Feedbacks:",
                    error
                );
            });
    }


    // ==================================================
    // AUSGABE
    // ==================================================

    return (

        <>

            <h1>
                Feedback-Verwaltung
            </h1>


            <p>
                Hier kannst Du eingegangene Feedbacks prüfen,
                freigeben, wieder ausblenden oder löschen.
            </p>


            <h2>
                Eingegangene Feedbacks
            </h2>


            {
                feedbacks.length === 0 ? (

                    <p>
                        Noch keine Feedbacks vorhanden.
                    </p>

                ) : (

                    <div className="admin-tabelle-container">

                        <table className="admin-tabelle admin-feedback-tabelle">

                            <thead>

                                <tr>

                                    <th>ID</th>
                                    <th>Datum</th>
                                    <th>Name</th>
                                    <th>Feedback</th>
                                    <th>Status</th>
                                    <th>Aktionen</th>

                                </tr>

                            </thead>


                            <tbody>

                                {
                                    feedbacks.map(
                                        (feedback) => (

                                            <tr
                                                key={feedback.id}
                                            >

                                                <td>
                                                    {feedback.id}
                                                </td>


                                                <td>
                                                    {feedback.datum}
                                                </td>


                                                <td>
                                                    {feedback.name}
                                                </td>


                                                <td className="admin-feedback-text">
                                                    {feedback.text}
                                                </td>


                                                <td>

                                                    {
                                                        feedback.freigegeben === 1
                                                            ? (

                                                                <span className="admin-status-frei">
                                                                    Freigegeben
                                                                </span>

                                                            )
                                                            : (

                                                                <span className="admin-status-vergeben">
                                                                    Nicht freigegeben
                                                                </span>

                                                            )
                                                    }

                                                </td>


                                                <td className="admin-feedback-aktionen">

                                                    {
                                                        feedback.freigegeben === 1
                                                            ? (

                                                                <button
                                                                    type="button"
                                                                    onClick={() =>
                                                                        handleSperren(
                                                                            feedback.id
                                                                        )
                                                                    }
                                                                >
                                                                    Ausblenden
                                                                </button>

                                                            )
                                                            : (

                                                                <button
                                                                    type="button"
                                                                    onClick={() =>
                                                                        handleFreigeben(
                                                                            feedback.id
                                                                        )
                                                                    }
                                                                >
                                                                    Freigeben
                                                                </button>

                                                            )
                                                    }


                                                    {" "}


                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            handleDelete(
                                                                feedback.id
                                                            )
                                                        }
                                                    >
                                                        Löschen
                                                    </button>

                                                </td>

                                            </tr>

                                        )
                                    )
                                }

                            </tbody>

                        </table>

                    </div>

                )
            }

        </>
    );
}


export default AdminFeedback;